import { MAP_TYPES } from '@deck.gl/carto';

const JOBACCESS30MINUTETRANSITDIFF_RESIDENTIALPRICEDIFF_DENSITYHOUSEHOLDSACREDIFF_HOUSEHOLDPOPULATIONDENSITYACRESDIFF_SOURCE_ID =
  'jobAccess30minuteTransitDiff_ResidentialPriceDiff_DensityHouseholdsAcreDiff_HouseholdPopulationDensityAcresDiffSource';

const source = {
  id: JOBACCESS30MINUTETRANSITDIFF_RESIDENTIALPRICEDIFF_DENSITYHOUSEHOLDSACREDIFF_HOUSEHOLDPOPULATIONDENSITYACRESDIFF_SOURCE_ID,
  type: MAP_TYPES.TILESET,
  connection: 'bmpo-smartmetro-09142026',
  data: 'us-con-gcp-npr-0000424-011325.bmpo_curated_dev.BMPO_tileset_02',
};

export default source;
